import {ActionService} from "../../../../../opportunity_actions_service/service/ActionService";
import {EmailActionComponent, EmailActionScope} from "../EmailAction";
import {ToastNotificationService} from "../../../../../utils/ToastNotificationService";
import {ActionComponent} from "../../action.component";
import {Opportunity} from "../../../../../opportunities/model/Opportunity";
import {ActionTypes} from "../../../../../action_status/model/ActionType";
import {UserGranredAuthorityName} from "modules/router/const/AllPermitions";

interface CustomerEmailActionScope extends EmailActionScope {
}

export class EmailCustomerAction extends EmailActionComponent {

    protected $scope: CustomerEmailActionScope;

    static instance = () => ActionComponent.instance(EmailCustomerAction);

    constructor($scope: CustomerEmailActionScope,
                actionService: ActionService,
                $exceptionHandler: ng.IExceptionHandlerService,
                $mdDialog: angular.material.IDialogService,
                toastService: ToastNotificationService) {
        super($scope, actionService, $exceptionHandler, $mdDialog, toastService);
    }

    protected getActionType = () => ActionTypes.EMAIL;

    protected getTitle = () => "Email Customer";

    protected getIcon = () => "/app/images/icons/mail.svg";

    protected getTooltipMessage(): string {
        if (!this.opportunity.customer.isSubscribedToEmailCampaign) {
            return "Customer has unsubscribed from receiving emails";
        } else {
            return super.getTooltipMessage();
        }
    }

    protected isDisabled(opportunity: Opportunity): boolean {
        return super.isDisabled(opportunity)
            || !opportunity.customer.isSubscribedToEmailCampaign || !this.hasAccessToCustomerEmail();
    }


    private hasAccessToCustomerEmail(): boolean {
        return this.principle.userAccessLevels.find(f => f.authorityName == UserGranredAuthorityName.OPPORTUNITY_CUSTOMER_MAILING).status
    }

}